var _rect, _rect2, _path, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "18.9 18.9 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 34.9082C18.9092 26.0716 26.0726 18.9082 34.9092 18.9082C43.7457 18.9082 50.9092 26.0716 50.9092 34.9082C50.9092 43.7448 43.7457 50.9082 34.9092 50.9082C26.0726 50.9082 18.9092 43.7448 18.9092 34.9082Z",
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1466_7607",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -37,
    y: -37,
    width: 144,
    height: 144
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 142.727,
    height: 142.727,
    transform: "translate(-36.3633 -36.3633)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9092,
    y: 18.9102,
    width: 32.4546,
    height: 32.4546,
    rx: 16.2273,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1466_7607)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10.1817,
    y: -8.72763,
    width: 90.3635,
    height: 90.3635
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(14.55px)",
      clipPath: "url(#bgblur_0_1466_7607_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1466_7607)",
    "data-figma-bg-blur-radius": 29.0909
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 36.4542C18.9092 27.5674 26.1133 20.3633 35.0001 20.3633C43.8869 20.3633 51.091 27.5674 51.091 36.4542C51.091 45.341 43.8869 52.5451 35.0001 52.5451C26.1133 52.5451 18.9092 45.341 18.9092 36.4542Z",
    fill: "black",
    fillOpacity: 0.04,
    style: {
      mixBlendMode: "hard-light"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 34.9082C18.9092 26.0716 26.0726 18.9082 34.9092 18.9082C43.7457 18.9082 50.9092 26.0716 50.9092 34.9082C50.9092 43.7448 43.7457 50.9082 34.9092 50.9082C26.0726 50.9082 18.9092 43.7448 18.9092 34.9082Z",
    fill: "#333333",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 34.9082C18.9092 26.0716 26.0726 18.9082 34.9092 18.9082C43.7457 18.9082 50.9092 26.0716 50.9092 34.9082C50.9092 43.7448 43.7457 50.9082 34.9092 50.9082C26.0726 50.9082 18.9092 43.7448 18.9092 34.9082Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 34.9082C18.9092 26.0716 26.0726 18.9082 34.9092 18.9082C43.7457 18.9082 50.9092 26.0716 50.9092 34.9082C50.9092 43.7448 43.7457 50.9082 34.9092 50.9082C26.0726 50.9082 18.9092 43.7448 18.9092 34.9082Z",
    fill: "white",
    style: {
      mixBlendMode: "plus-darker"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9092,
    y: 18.9082,
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0313 35.0495C30.0313 34.9288 30.0515 34.8201 30.0917 34.7235C30.136 34.627 30.2044 34.5344 30.297 34.4458L36.4124 28.5357C36.5613 28.3868 36.7444 28.3123 36.9617 28.3123C37.1066 28.3123 37.2374 28.3485 37.3541 28.421C37.4749 28.4894 37.5695 28.582 37.6379 28.6987C37.7103 28.8154 37.7465 28.9462 37.7465 29.0911C37.7465 29.3044 37.6681 29.4915 37.5111 29.6525L31.9088 35.0495L37.5111 40.4405C37.6681 40.6015 37.7465 40.7886 37.7465 41.002C37.7465 41.1509 37.7103 41.2837 37.6379 41.4004C37.5695 41.5211 37.4749 41.6157 37.3541 41.6841C37.2374 41.7525 37.1066 41.7868 36.9617 41.7868C36.7444 41.7868 36.5613 41.7123 36.4124 41.5634L30.297 35.6532C30.2044 35.5647 30.136 35.4721 30.0917 35.3755C30.0515 35.2749 30.0313 35.1663 30.0313 35.0495Z",
    fill: "#404040",
    style: {
      mixBlendMode: "plus-darker"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1466_7607",
    x: -10.1817,
    y: -8.72763,
    width: 90.3635,
    height: 90.3635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.27273,
    result: "effect1_foregroundBlur_1466_7607"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1466_7607_clip_path",
    transform: "translate(10.1817 8.72763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 36.4542C18.9092 27.5674 26.1133 20.3633 35.0001 20.3633C43.8869 20.3633 51.091 27.5674 51.091 36.4542C51.091 45.341 43.8869 52.5451 35.0001 52.5451C26.1133 52.5451 18.9092 45.341 18.9092 36.4542Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedLeft);
export default __webpack_public_path__ + "static/media/rounded-left.2231ecbab876d41b30d35f79473be29c.svg";
export { ForwardRef as ReactComponent };